import { render, staticRenderFns } from "./CreatePopupBanner.vue?vue&type=template&id=287ccbea"
import script from "./CreatePopupBanner.vue?vue&type=script&lang=js"
export * from "./CreatePopupBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports